import React from 'react'


import { translate } from 'react-i18next';

var ButtonGroupRadio = React.createClass({

  render() {
      const { t } = this.props;
    var name = this.props.inputProps.name;
    var value = this.props.inputProps.value;

    var isChecked = (this.props.inputProps.value === this.props.inputProps.radioValue);
    var onChange = this.props.inputProps.onChange;
    var className = "btn btn-primary";    

    if(isChecked) {
      className += " active";
    }

    return (
      <label className={className}>
        <input type="radio" name={name} value={value} id={value} autoComplete="off" onChange={onChange} checked={isChecked} title={t('common:'+value+'_title')}  /> 
        {t('common:'+value+'_label')}
      </label>
      );

  }
});

export default  translate('common', { wait: true })(ButtonGroupRadio);